/* eslint-disable */
document.addEventListener('DOMContentLoaded', () => {
	// alert("cdpage js loaded successfully");
	const formContainer = document.getElementById('atsCareerDetailsModal');
	const applyButton = document.getElementById('ats_cd_submit_modal');
	const closeButton = document.getElementById('ats-cdpage-close-icon');
	const applyFormButton = document.getElementById('atsCdFormSubmit');
	const requiredInputs = document.querySelectorAll('#ats-career-details-form input[required]');
	const concentValidation = document.getElementById('ats-cdpage-consent-validation');
	const resumeInput = document.getElementById('ats-cdpage-resume');
	const uploadButton = document.getElementById('ats-cdpage-resume-upload');
	const fileNameDisplay = document.getElementById('ats-cdpage-file-name');
	const nonceInput = document.getElementById('career-nonce-form');
	const applicationComplete = document.getElementById('application-complete');
	const completeApplicationClose = document.getElementById('complete-close');
	const completeApplocationButtonClose = document.getElementById('complete-close-button');
	const copyLink = document.getElementById('copyLink');
	const fileValidationMessage = document.getElementById('validated-file');
	const fileSizeValidationMessage = document.getElementById('validated-file-size');
	const fileExsistsValidationMessage = document.getElementById('validated-file-exsists');
	const formButton = document.getElementById('ats-cdpage-form-button');

	if (fileValidationMessage) {
		fileValidationMessage.style.display = 'none';
	}
	if (fileSizeValidationMessage) {
		fileSizeValidationMessage.style.display = 'none';
	}
	if (fileExsistsValidationMessage) {
		fileExsistsValidationMessage.style.display = 'none';
	}
	if (copyLink) {
		copyLink.addEventListener('click', () => {
			const link = copyLink.children[0].getAttribute('href');
			const tempTextarea = document.createElement('textarea');
			tempTextarea.value = link;
			document.body.appendChild(tempTextarea);
			tempTextarea.select();
			document.execCommand('copy');
			document.body.removeChild(tempTextarea);
			copyLink.children[2].style.visibility = 'visible';
			setTimeout(function () {
				copyLink.children[2].style.visibility = 'hidden';
			}, 2000);
		});
	}
	if (applicationComplete) {
		applicationComplete.style.display = 'none';
	}
	// Function to validate the file size
	function validateFileSize(fileInput) {
		const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB in bytes
		const fileSize = fileInput.files[0].size;
		return fileSize <= maxSizeInBytes;
	}

	function openPopup(event) {
		event.preventDefault();
		formContainer.style.display = 'block';
		concentValidation.style.display = 'none';
		document.body.classList.add('scroll-fix');
	}

	// Function to validate the file format
	function validateFileFormat(fileInput) {
		const allowedFormats = [
			'pdf',
			'doc',
			'docx',
			'ppt',
			'pptx',
			'jpg',
			'jpeg',
			'png',
			'gif',
			'zip',
			'webp',
		];
		const fileName = fileInput.value.toLowerCase();
		const fileExtension = fileName.split('.').pop();
		return allowedFormats.includes(fileExtension);
	}

	function validateForm() {
		let empty = true;
		// const selectElement = document.getElementById('ats_cdpage_experience');
		// if (selectElement) {
		// 	const selectValue = selectElement.value;
		// 	const text = document.createElement('p');
		// 	text.classList.add('contact-error');
		// 	if (!selectValue) {
		// 		empty = false;
		// 	}
		// 	if (!selectValue && !selectElement.nextElementSibling) {
		// 		empty = false;
		// 		const errorMessage = 'Please fill the required fields';
		// 		const textContent = document.createTextNode(errorMessage);
		// 		text.appendChild(textContent);
		// 		selectElement.parentNode.appendChild(text);
		// 	} else if (selectValue && selectElement.nextElementSibling) {
		// 		selectElement.nextElementSibling.remove();
		// 	}
		// }
		requiredInputs.forEach(function (input) {
			const checkbox = document.getElementById('ats_cdpage_consent');
			const isChecked = checkbox.checked;
			const text = document.createElement('p');
			text.classList.add('contact-error');
			const val = input.value.trim();


			if (input.type !== 'checkbox' && input.type !== 'file' && input.nextElementSibling) {
				input.nextElementSibling.remove();
			}
			if ((val.length === 0 || typeof val === 'undefined') && input.type !== 'file') {
				empty = false;
				const errorMessage = 'Please fill the required fields';
				const textContent = document.createTextNode(errorMessage);
				text.appendChild(textContent);
				input.parentNode.appendChild(text);
			}
			if (!resumeInput.files[0]) {
				fileExsistsValidationMessage.style.display = 'block';
				empty = false;
			}
			if (input.type === 'file' && resumeInput.files[0]) {
				fileExsistsValidationMessage.style.display = 'none';
				const fileFormat = validateFileFormat(resumeInput);
				const fileSize = validateFileSize(resumeInput);
				if (fileSize === false) {
					fileSizeValidationMessage.style.display = 'block';
					empty = false;
				} else {
					fileSizeValidationMessage.style.display = 'none';
				}
				if (fileFormat === false) {
					fileValidationMessage.style.display = 'block';
					empty = false;
				} else {
					fileValidationMessage.style.display = 'none';
				}
			}
			if(input.name === 'ats_cdpage_mobile_number' && val.length < 10 && val.length !== 0 ){
				empty = false;
				const errorMessage = 'Please fill a valid mobile number.';
				const textContent = document.createTextNode(errorMessage);
				text.appendChild(textContent);
				input.parentNode.appendChild(text);

			}
			if(input.name === 'ats_cdpage_email'  && val.length !== 0){
				const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				const validEmail = pattern.test(val);
				if(!validEmail){
				empty = false;

					const errorMessage = 'Please fill a valid email address.';
					const textContent = document.createTextNode(errorMessage);
					text.appendChild(textContent);
					input.parentNode.appendChild(text);
				}

			}
			if (input.type === 'checkbox' && !isChecked) {
				empty = false;
				concentValidation.style.display = 'block';
			} else if (input.type === 'checkbox' && isChecked) {
				concentValidation.style.display = 'none';
			}
		});
		return empty;
	}

	function closePopup(event) {
		event.preventDefault();
		formContainer.style.display = 'none';
		document.body.classList.remove('scroll-fix');
	}

	function uploadFile() {
		const formdata = new FormData();
		const fileInput = document.getElementById('ats-cdpage-resume');
		const form = document.getElementById('ats-career-details-form');
		const file = fileInput.files[0];
		const recaptchaToken = document.getElementById('recaptcha_token');
		const years = parseInt(form.ats_cdpage_exp_years.value || 0, 10);
		const months = parseInt(form.ats_cdpage_exp_months.value || 0, 10);
		// Convert months into fraction of a year
		const totalYears = years + (months / 12);

		// Round to one decimal place (e.g., 4.25 → 4.3)
		const experienceInYears = parseFloat(totalYears.toFixed(1));
		formdata.append('file', file); // phpcs:ignore.
		formdata.append('name', form.ats_cdpage_first_name.value); // phpcs:ignore.
		formdata.append('lastname', form.ats_cdpage_last_name.value); // phpcs:ignore.
		formdata.append('email', form.ats_cdpage_email.value); // phpcs:ignore.
		formdata.append('mobile', form.ats_cdpage_mobile_number.value); // phpcs:ignore.
		formdata.append('experience', experienceInYears); // phpcs:ignore.
		formdata.append('expCTC', form.ats_cdpage_expctc.value); // phpcs:ignore.
		formdata.append('currCTC', form.ats_cdpage_currctc.value); // phpcs:ignore.
		formdata.append('currLocation', form.ats_cdpage_loc.value); // phpcs:ignore.
		formdata.append('noticePeriod', form.ats_cdpage_notice.value); // phpcs:ignore.
		formdata.append('nonce', form.nonce.value); // phpcs:ignore.
		formdata.append('role', form.role.value); // phpcs:ignore.
		formdata.append('location', form.location.value); // phpcs:ignore.
		formdata.append('careerid', form.careerid.value); // phpcs:ignore.
		formdata.append('toMail', form.toMail.value); // phpcs:ignore.
		formdata.append('recaptcha', recaptchaToken.value); // phpcs:ignore.
		formdata.append('action', 'ats_career_form'); // phpcs:ignore.
		fetch(
			ajaxload_params.ajaxurl, // eslint-disable-line
			{
				method: 'POST',
				body: formdata,
			},
		)
			.then(response => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json(); // Parse the JSON response
			})
			.then(data => {
				if (data.success) {
					formContainer.style.display = 'none';
					if (applicationComplete) {
						applicationComplete.style.display = 'flex';
					}
					document.body.classList.remove('scroll-fix');
				} else {
					if (applicationComplete) {
						applicationComplete.style.display = 'flex';
					}
					document.body.classList.remove('scroll-fix');
					console.error('Upload Failed:', data.message);
				}
			})
			.catch(error => {
				if (applicationComplete) {
					applicationComplete.style.display = 'flex';
				}
				document.body.classList.remove('scroll-fix');
				console.error('Error:', error);
			});
	}

	function closePopupSubmit(event) {
		event.preventDefault();
		if (validateForm() === true) {
			formButton.textContent = 'Applying...';
			formButton.setAttribute('disabled', true);
			uploadFile();
		}
	}

	if (uploadButton) {
		uploadButton.addEventListener('click', function () {
			resumeInput.click(); // Trigger the file input click event
		});
	}
	if (resumeInput) {
		resumeInput.addEventListener('change', function () {
			const selectedFile = resumeInput.files[0];
			if (selectedFile) {
				fileNameDisplay.textContent = selectedFile.name;
			} else {
				fileNameDisplay.textContent = '';
			}
		});
	}
	function closeCompletePopup(event) {
		event.preventDefault();
		if (applicationComplete) {
			applicationComplete.style.display = 'none';
		}
		window.location.reload();
	}
	if (applyButton) {
		applyButton.addEventListener('click', openPopup);
	}
	if (closeButton) {
		closeButton.addEventListener('click', closePopup);
	}
	if (applyFormButton) {
		applyFormButton.addEventListener('click', closePopupSubmit);
	}
	if (completeApplicationClose) {
		completeApplicationClose.addEventListener('click', closeCompletePopup);
	}
	if (completeApplocationButtonClose) {
		completeApplocationButtonClose.addEventListener('click', closeCompletePopup);
	}

	grecaptcha.ready(function () {
		//eslint-disable-line
		grecaptcha //eslint-disable-line
			.execute(ajaxload_params.recaptchaSiteKey, { action: 'ats_career_form' }) //eslint-disable-line
			.then(function (token) {
				const tokenInput = document.createElement('input');
				tokenInput.type = 'hidden';
				tokenInput.id = 'recaptcha_token';
				tokenInput.name = 'recaptcha_token';
				tokenInput.value = token;
				const recaptchaContainer = document.getElementById('career-recaptcha');
				if (recaptchaContainer) {
					recaptchaContainer.innerHTML = ''; // Clear existing content
					recaptchaContainer.appendChild(tokenInput);
				}
			});
	});
});
